import "./bootstrap";
import "../css/app.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { createApp, h } from "vue";
import { createInertiaApp } from "@inertiajs/vue3";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import { ZiggyVue } from "../../vendor/tightenco/ziggy";
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { aliases, mdi } from "vuetify/lib/iconsets/mdi";
import "@mdi/font/css/materialdesignicons.css";
import locale from "@/locale.js";
import { createPinia } from "pinia";
AOS.init();
const pinia = createPinia();
const vuetify = createVuetify({
    icons: {
        defaultSet: "mdi",
        aliases,
        sets: {
            mdi,
        },
    },
    components,
    directives,
    locale: {
        locale: localStorage.getItem("locale") || "ckb",
        messages: locale,
        rtl: {
            ckb: true,
            ar: true,
            en: false,
        },
    },
    theme: {
        defaultTheme: "light",
        themes: {
            light: {
                colors: {
                    appBarColor: "#174b5c",
                    orderBtn: "#c37e3a",
                    orderBtnPlus: "#c37e3a",
                    orderBtnMinus: "#EAD7BB",
                },
            },
            dark: {
                colors: {
                    appBarColor: "#113946",
                    orderBtn: "#dc9247",
                    orderBtnPlus: "#c37e3a",
                    orderBtnMinus: "#EAD7BB",
                },
            },
        },
    },
});

const appName = import.meta.env.VITE_APP_NAME || "MekhakCafe";
createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) =>
        resolvePageComponent(
            `./Pages/${name}.vue`,
            import.meta.glob("./Pages/**/*.vue")
        ),
    setup({ el, App, props, plugin }) {
        return createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(vuetify)
            .use(ZiggyVue)
            .use(pinia)
            .mount(el);
    },
    progress: {
        color: "#1d7468",
    },
});
